import ApiService from '@/services/api.service.js';

export const RegionService = {

  getRegions: function (data) {
    return ApiService.get('/regions');
  },

  getApplicationRegionsWithCountries: function (data) {
    return ApiService.get('/regions-countries/application');
  },

  getRegionsWithCountries: function (data) {
    return ApiService.get('/regions-countries');
  }
}

export default RegionService